import { type Admin, type AdminMembershipPayload } from 'src/shared/types/admin';
import { type Company } from 'src/shared/types/company';
import { AdminScope, type AdminFormValues, type SelectableSubsidiary } from './types';

export const getAdminScope = ({ holdingMembership }: Pick<Admin, 'holdingMembership'>): AdminScope =>
  holdingMembership !== null ? AdminScope.HOLDING : AdminScope.COMPANY;

export const isSameEmail = (email: string, otherEmail?: string): boolean =>
  otherEmail !== undefined && email.toLowerCase() === otherEmail.toLowerCase();

export const mapAdminToFormValues = (admin: Admin): AdminFormValues => ({
  email: admin.email,
  scope: getAdminScope(admin),
  subsidiaryCoreIds: admin.companyMemberships?.map(({ subsidiaryCoreId }) => subsidiaryCoreId) ?? []
});

export const mapFormValuesToMembershipPayload = ({
  scope,
  subsidiaryCoreIds
}: AdminFormValues): AdminMembershipPayload => {
  if (scope === AdminScope.HOLDING) {
    return { holdingMembership: {} };
  }
  if (scope === AdminScope.COMPANY) {
    return { companyMemberships: subsidiaryCoreIds.map(subsidiaryCoreId => ({ subsidiaryCoreId })) };
  }
  throw new Error('An administrator scope is required');
};

export const mapCompaniesToSelectableSubsidiaries = (companies: Company[]): SelectableSubsidiary[] =>
  companies.reduce<SelectableSubsidiary[]>((subsidiaries, company) => {
    const coreId = company.metadata?.legacyCore?.id;
    if (coreId === undefined || coreId === null) {
      return subsidiaries;
    }
    subsidiaries.push({ coreId: String(coreId), name: company.name, taxIdentifier: company.taxIdentifier });
    return subsidiaries;
  }, []);
